var _templateObject, _templateObject2;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { bool, string, number } from 'prop-types';
import Text from '../../Text';
export var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  ", "\n"])), function (_ref) {
  var disabled = _ref.disabled,
      error = _ref.error,
      _ref$theme$yoga = _ref.theme.yoga,
      colors = _ref$theme$yoga.colors,
      input = _ref$theme$yoga.components.input;
  return "\n    margin-top: " + input.helper.margin.top + "px;\n\n    color: " + (error ? colors.feedback.attention[1] : input.helper.color["default"]) + ";\n    " + (disabled ? "color: " + colors.text.disabled + ";" : '') + "\n  ";
});
var Info = styled(Text.Small)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  color: currentColor;\n  ", "\n"])), function (_ref2) {
  var hideMaxLength = _ref2.hideMaxLength,
      input = _ref2.theme.yoga.components.input;
  return "\n    font-size: " + input.helper.font.size + "px;\n\n    " + (hideMaxLength ? 'display: none;' : '') + "\n    ";
});

var Helper = function Helper(_ref3) {
  var disabled = _ref3.disabled,
      error = _ref3.error,
      helper = _ref3.helper,
      maxLength = _ref3.maxLength,
      length = _ref3.length,
      hideMaxLength = _ref3.hideMaxLength;
  return /*#__PURE__*/React.createElement(Wrapper, {
    disabled: disabled,
    error: error
  }, (error || helper) && /*#__PURE__*/React.createElement(Info, {
    as: "span"
  }, error || helper), maxLength && !hideMaxLength && /*#__PURE__*/React.createElement(Info, {
    as: "span"
  }, length, "/", maxLength));
};

Helper.propTypes = {
  disabled: bool,
  error: string,
  helper: string,
  maxLength: number,
  length: number,
  hideMaxLength: bool
};
Helper.defaultProps = {
  disabled: undefined,
  error: undefined,
  helper: undefined,
  maxLength: undefined,
  length: undefined,
  hideMaxLength: undefined
};
export default Helper;